import { c as _c } from "react/compiler-runtime";
import { PRODUCT_COMPARE_DATA_TEST } from '@/app/lcv/components/sections/compare/tracking';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export const CompareRemark = () => {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = createDataAttributes({
      test: PRODUCT_COMPARE_DATA_TEST.remark
    });
    t1 = <p className="font-noto-bold">หมายเหตุ</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li>ราคาที่ปรากฎเป็นราคาขายปลีกแนะนำเท่านั้น รุ่นที่ปรากฎในภาพอาจแตกต่างจากรูปจริง โปรดศึกษารายละเอียดรุ่นรถและอุปกรณ์จากตารางด้านบน</li>;
    t3 = <li>รายละเอียดต่างๆ อาจมีการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</li>;
    t4 = <li>สีที่ปรากฏในภาพอาจแตกต่างจากสีจริง</li>;
    t5 = <li>อุปกรณ์มาตรฐานไม่รวมอุปกรณ์ตกแต่งเสริม</li>;
    t6 = <li>ก่อนใช้งานโปรดศึกษาวิธีการใช้งานจากคู่มือการใช้รถและคู่มือการใช้อุปกรณ์เสริมโดยละเอียด เพื่อความปลอดภัยและประสิทธิภาพในการใช้งาน</li>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-caption px-4 py-10" {...t0}>{t1}<ul className="list-ul mt-1">{t2}{t3}{t4}{t5}{t6}<li>ระบบ Apple CarPlay เป็นลิขสิทธิ์ของ Apple Inc. ซึ่งรองรับการใช้งานระบบและอุปกรณ์ตามที่ระบุไว้ใน{" "}<a href="http://www.apple.com/th/ios/carplay" target="_blank">Apple CarPlay</a></li></ul></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};